import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('farmSelectPanelField');

    return {
        NO_FARMS_FOUND: t('noFarmsFound'),
        SEARCH: t('search'),
        SELECT_A_CLIENT_TO_SEE_FARMS: t('selectAClientToSeeFarms')
    };
};

export default useTranslation;
